import React from 'react';
import { RenderOnClient } from '@atlassian/jira-ssr-toolkit/src/render-on-client.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { LazyNotifications as Notifications } from './lazy-badge/index.tsx';

export const Badge = ({ releaseNotesNotifications = 0 }: { releaseNotesNotifications: number }) => {
	if (fg('jfp-magma-4013-fix-top-nav-ssr-hydration')) {
		return (
			<RenderOnClient>
				{releaseNotesNotifications > 0 ? (
					<Notifications max={3} appearance="primary">
						{releaseNotesNotifications}
					</Notifications>
				) : null}
			</RenderOnClient>
		);
	}

	return releaseNotesNotifications > 0 && !__SERVER__ ? (
		<Notifications max={3} appearance="primary">
			{releaseNotesNotifications}
		</Notifications>
	) : null;
};
